import { serverTimestamp, type FieldValue } from 'firebase/firestore'
import {
  typedDoc,
  getDocument,
  setDocument,
} from '@/lib/firebase/firestore'
import type { TermsOfServiceDocument, TermsOfServiceSection } from '@/types'

type TermsOfServicePayload = {
  sections: TermsOfServiceSection[]
  lastUpdated: FieldValue
}

const tosRef = () => typedDoc<TermsOfServiceDocument>('legalDocuments', 'terms-of-service')

export const adminTermsOfServiceService = {
  async get(): Promise<TermsOfServiceDocument | null> {
    return getDocument(tosRef())
  },

  async save(sections: TermsOfServiceSection[]): Promise<void> {
    const payload: TermsOfServicePayload = {
      sections,
      lastUpdated: serverTimestamp(),
    }
    await setDocument(tosRef(), payload as unknown as TermsOfServiceDocument)
  },
}
